// extracted by mini-css-extract-plugin
export default {"TextAndVideo2":"style_TextAndVideo2__f8sps","title":"style_title__-6Nd9","video3":"style_video3__0Oo9o"};